import { rhythm } from './typography'

export const bottomBorder = `
border-bottom: 1px solid hsla(0,0%,0%,0.2);
padding-bottom: ${rhythm(1)};
`
